module.exports = __webpack_public_path__ + "static/words-that-work-893a5b97748d0e36e75d323753450f61.jpg";